import styled, { css } from 'styled-components'

const withDescriptionCSS = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 32px;

  .indicator-legend-row {
    flex-direction: column;

    p {
      // margin-bottom: 4px;
      margin-bottom: 32px;
    }

    .indicator-legend-description {
      color: ${ (props) => props.theme.colors.grau2 };
      font-size: 14px;
      margin-bottom: 32px;
    }
  }

  @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
    grid-template-columns: 1fr;
  }
`

export const IndicatorLegend = styled.div`
  margin-top: 16px;

  .indicator-legend-row {
    display: flex;
    align-items: baseline;

    .indicator-legend-rating {
      margin-right: 16px;
      min-width: 24px;
    }

    @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
      flex-direction: column;
    }
  }

  ${ (props) => props.withDescription && withDescriptionCSS }
`
